import React, { Fragment, useEffect, useState } from "react"
import "../../SignIn/SignIn.scss"
import { FormGroups } from "../../../components/ReusableComponents/FormGroups/FormGroups"
import { FieldControl, FieldGroup } from "react-reactive-form"
import { TextInput } from "../../../components/UI/FormInput/FormInput"
import { messageService } from "../../../services/subscriberService"
import {
  accessTokenApi,
  linkGym,
  resendVerifyEmail,
  updateGymWaiver,
} from "../../../services/CallApi"
import { ErrorUI } from "../../../components/UI/Modals/Modals"
import { Button } from "../../../components/UI/Button/button"
import { useDispatch } from "react-redux"
import { profileActions } from "../../../store"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"

const Waiver = ({ userDetail, submitData, updateProfileData, ...props }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const updateWaiver = () => {
    updateGymWaiver(props.profile.defaultGym.gym_id, true).then((res) => {
      if (res.status) {
        dispatch(profileActions.updateProfileData(res.data))
      } else {
        ErrorUI(res.list, () => {
          updateWaiver()
        })
      }
    })
  }
  const handleSubmit = (e) => {
    e.preventDefault()
  }
  const waiverMsg = props.profile.defaultGym.waiver_acceptance_message

  return waiverMsg ? (
    <Fragment>
      <br />
      <p>{waiverMsg}</p>
      <br />
      <Button
        type="button"
        label="I Accept"
        handleClick={() => {
          updateWaiver()
        }}
      />
    </Fragment>
  ) : null
}

export default Waiver
